import React, { useEffect, useState } from 'react';
import { CrownIcon } from './Icons';
const buyers = [{
  name: 'Marcelo',
  province: 'Buenos Aires'
}, {
  name: 'Javier',
  province: 'Córdoba'
}, {
  name: 'Diego',
  province: 'Santa Fe'
}, {
  name: 'Rubén',
  province: 'Mendoza'
}, {
  name: 'Gastón',
  province: 'Tucumán'
}, {
  name: 'Pablo',
  province: 'Entre Ríos'
}, {
  name: 'Hernán',
  province: 'Salta'
}];
export function SocialProofPopup() {
  const [currentBuyer, setCurrentBuyer] = useState<{
    name: string;
    province: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      showPopup();
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible || !currentBuyer) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 rounded-lg shadow-2xl p-4 flex items-center gap-4 z-50 max-w-[320px] bg-gradient-to-r from-yellow-900/95 to-yellow-800/95 border border-yellow-500/60" style={{
    animation: 'slideIn 0.4s ease-out, slideOut 0.3s ease-in 3.7s forwards'
  }} data-id="element-486">
      <div className="bg-yellow-400/20 p-2 rounded-full shrink-0" data-id="element-487">
        <CrownIcon className="w-6 h-6 text-yellow-400" data-id="element-488" />
      </div>
      <div data-id="element-489">
        <p className="text-sm font-bold text-yellow-100 leading-tight" data-id="element-490">
          {currentBuyer.name} de {currentBuyer.province}
        </p>
        <p className="text-xs text-yellow-300 mt-1 font-semibold" data-id="element-491">
          compró el{' '}
          <span className="text-yellow-400 font-black" data-id="element-492">Pack Premium</span> ⭐
        </p>
      </div>
    </div>;
}